import clsx from "clsx";
import React, { useState } from "react";

interface AccordionItemProps {
	accordionKey: string;
	children: React.ReactNode;
	headerContent?: React.ReactNode;
	label: string;
}

export function AccordionItem({
	accordionKey,
	label,
	headerContent,
	children,
}: AccordionItemProps) {
	const [groupCollapsed, setGroupCollapsed] = useState(false);

	return (
		<div className={clsx("accordion-item", { expanded: !groupCollapsed })}>
			<div className="accordion-header">
				<button
					type="button"
					className="btn accordion-toggle"
					id={accordionKey}
					aria-controls={`section-${accordionKey}`}
					aria-expanded={!groupCollapsed}
					onClick={() => setGroupCollapsed(!groupCollapsed)}
				>
					<span>{label}</span>
				</button>
				{headerContent}
			</div>

			<section
				className="accordion-content"
				id={`section-${accordionKey}`}
				aria-labelledby={accordionKey}
			>
				{children}
			</section>
		</div>
	);
}
